import { useTranslation } from "react-i18next";
import { Icon } from "./documents/Icon";

const Item = ({ name, type, onDelete, onDownload }) => {
    const { t } = useTranslation("common");
    
    return (
        <div className="main-content__documents-card">
            <Icon type={type} />
            <div className="main-content__documents-card-title">
                <span>{name}</span>
            </div>
            <div className="main-content__documets-card-description">
                
                <div 
                    style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        width: "200px",
                        display: "inline-block",
                        textAlign: "center"
                    }}
                >
                    {type}
                </div>
            </div>
            <div className="main-content__documents-card-actions">
                <button onClick={onDownload}>
                    <i className="fa-regular fa-download"></i>
                    <span>{t("download")}</span>
                </button>
                {onDelete && (
                    <button onClick={onDelete}>
                        <i className="fa-regular fa-trash-can"></i>
                        <span>{t("deleteDocument")}</span>
                    </button>
                )}
            </div>
        </div>
    );
};

export default Item;
